/**
 * Constantes para o componente Result Counter
 */

/**
 * Ícones baseados no contexto da pergunta/resultado
 */
export const COUNTER_ICONS: { [key: string]: string } = {
    // Membros
    'membros': '👥',
    'member': '👥',
    'pessoas': '👥',
    'ativos': '✅',
    'inativos': '⏸️',
    'congregados': '🙏',
    'batizados': '💧',

    // Gênero
    'homens': '👨',
    'mulheres': '👩',
    'masculino': '👨',
    'feminino': '👩',

    // Grupos
    'grupos': '👨‍👩‍👧‍👦',
    'celulas': '🏠',
    'divisoes': '📁',
    'lideres': '👑',

    // Financeiro
    'dizimos': '💰',
    'ofertas': '🎁',
    'entradas': '📥',
    'saidas': '📤',

    // Eventos
    'aniversariantes': '🎂',
    'eventos': '📅',

    // Default
    'default': '📊'
};

/**
 * Obtém o ícone baseado no título ou contexto
 */
export function getCounterIcon(title: string): string {
    const lowerTitle = title.toLowerCase();

    for (const [key, icon] of Object.entries(COUNTER_ICONS)) {
        if (lowerTitle.includes(key)) {
            return icon;
        }
    }

    return COUNTER_ICONS['default'];
}
